import React, {Component} from 'react'
import Wyszukiwarka from "./Wyszukiwarka";
import '../styles/Wyszukiwarka.css'
import WyszukiwarkaService from "./WyszukiwarkaService";
import TopIf from '../topComponents/if/TopIf'
import PokazSzczegoly from "./wyszukiwarkaComponents/PokazSzczegoly";
import Koszyk from "../koszyk/Koszyk";
import Footer from "../shared/Footer";
import strings from "../strings/localeStrings";
import $ from 'jquery'
import ShowCennik from "./wyszukiwarkaComponents/szczegolyComponents/ShowCennik";
import {NotificationManager} from "react-notifications";
import WynikiComponent from "./WynikiComponent";
import {Link} from "react-router-dom";
import {Button} from "react-bootstrap";
import moment from "moment";

const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait)
    }
};

export default class Wyniki extends Component {

    constructor(props) {
        super(props);

        let powrotny = false;

        if (window.location.href.indexOf('powrotny') > -1) {
            powrotny = true
        }

        let dataTimer = [];

        if (sessionStorage.getItem('koszyk') === null || sessionStorage.getItem('koszyk') === '') {
            dataTimer = [];
        } else {
            dataTimer = JSON.parse(sessionStorage.getItem('koszyk'))
        }

        this.state = {
            scrollPositionY: 0,
            data: [],
            dataTimer: dataTimer,
            dataPowrot: [],
            loading: true,
            buttonLoader: true,
            wyswietlSzczegoly: {},
            wyswietlCennik: {},
            odswiezKoszyk: true,
            powrotny: powrotny,
            odliczanie: '',
            miejscowoscOne: '',
            miejscowoscTwo: '',
            przystankiDocelowePowrotu: '',
            miejsceWyjazduPrzystanekPowrotu: '',
            miejsceDocelowePrzystanekPowrotu: '',
            przystankiWyjazduPowrotu: '',
            containerHeight: 0,
            selectOtwarty: false
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({dataTimer: JSON.parse(sessionStorage.getItem('koszyk'))})
    }

    odliczanie() {
        if (this.state.dataTimer !== '' && this.state.dataTimer !== null && this.state.dataTimer !== [] && this.state.dataTimer.length !== 0) {
            let timer = moment(sessionStorage.getItem('koszykTimer')).add(-1, 'seconds').format('mm:ss');
            if (timer === 'Invalid date') {
                timer = ''
            }
            this.setState({
                odliczanie: timer,
                dataTimer: JSON.parse(sessionStorage.getItem('koszyk'))
            })
        }
    }

    componentWillMount() {
        this.timer = setInterval(() => this.odliczanie(), 1000)

        window.scrollTo(0, 0);

        let ok = true;
        let mW = this.props.match.params.mW;
        let mD = this.props.match.params.mD;
        let data = this.props.match.params.data;
        let godzina = this.props.match.params.godzina;
        let dataPow = this.props.match.params.dataPow;
        let godzinaPow = this.props.match.params.godzinaPow;
        let hourRegEx = /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$/;

        if (window.location.href.indexOf("powrotny") > -1) {
            if (!this.isValidDate(dataPow)) {
                ok = false
            }
            if (!hourRegEx.test(godzinaPow)) {
                ok = false
            }
        }

        if (!isNaN(parseInt(mW))) {
            if (parseInt(mW) <= 0 || parseInt(mW) > 999) {
                ok = false
            }
        } else {
            ok = false
        }

        if (!isNaN(parseInt(mD))) {
            if (parseInt(mD) <= 0 || parseInt(mD) > 999) {
                ok = false
            }
        } else {
            ok = false
        }

        if (!this.isValidDate(data)) {
            ok = false
        }
        if (!hourRegEx.test(godzina)) {
            ok = false
        }

        if (ok) {
            setTimeout(
                function () {
                    if (window.location.href.indexOf("powrotny") > -1) {
                        WyszukiwarkaService.getRozklad(this.props.match.params.mW, this.props.match.params.mD, this.props.match.params.data, this.props.match.params.godzina)
                            .then(function (response) {
                                this.setState({data: response.data, loading: false, buttonLoader: false})
                            }.bind(this));
                        if (this.state.miejscowoscOne !== null && this.state.miejscowoscTwo !== null){
                            WyszukiwarkaService.getPrzystanki(this.state.miejscowoscTwo, this.state.miejscowoscOne)
                                .then(function (response) {
                                    let res = response.data;
                                    let przystanekWyjazdu = res[0][0].idPr;
                                    let przystanekDocelowy = res[1][res[1].length - 1].idPr;
                                    WyszukiwarkaService.getRozklad(przystanekWyjazdu, przystanekDocelowy, this.props.match.params.dataPow, this.props.match.params.godzinaPow)
                                        .then(function (res) {
                                            this.setState({dataPowrot: res.data, powrotny: true})
                                        }.bind(this))
                                }.bind(this))
                        } else {
                            NotificationManager.error("", "Wystąpił błąd ", 5000);
                        }
                    } else {
                        WyszukiwarkaService.getRozklad(this.props.match.params.mW, this.props.match.params.mD, this.props.match.params.data, this.props.match.params.godzina)
                            .then(function (response) {
                                this.setState({data: response.data, loading: false, buttonLoader: false})
                            }.bind(this))
                    }
                }
                    .bind(this),
                500
            );
        } else {
            this.setState({bledneDane: true, loading: false})
        }
    }

    isValidDate(dateString) {
        let regEx = /^\d{4}-\d{2}-\d{2}$/;
        if (!dateString.match(regEx)) return false;  // Invalid format
        let d = new Date(dateString);
        console.log(d.getTime())
        if (isNaN(d.getTime())) return false; // Invalid date
        return d.toISOString().slice(0, 10) === dateString;
    }

    componentDidMount() {
        if (this.state.selectOtwarty) {
            return null
        } else {
            return window.addEventListener('scroll', debounce(this.handleScroll, 0.5))
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer);
        return window.removeEventListener('scroll', debounce(this.handleScroll, 1))
    }

    handleScroll = () => {
        if (document.getElementsByClassName('is-open').length === 0) {

            let scrollPositionY = +window.scrollY;
            let koszykHeight = $("#koszykHeight").height();
            if ((document.documentElement.offsetHeight - 1200 - koszykHeight) < scrollPositionY) {
                scrollPositionY = (document.documentElement.offsetHeight - 1200 - koszykHeight)
            }
            this.setState({scrollPositionY: scrollPositionY})

        }
    };

    odswiezHeader() {
        this.setState({odswiezKoszyk: !this.state.odswiezKoszyk})
    }

    pokazSzczegoly(id) {
        this.setState({
            wyswietlSzczegoly: {
                ...this.state.wyswietlSzczegoly,
                [id]: !this.state.wyswietlSzczegoly[id]
            }
        });
    }

    pokazCennik(id) {
        this.setState({
            wyswietlCennik: {
                ...this.state.wyswietlCennik,
                [id]: !this.state.wyswietlCennik[id]
            }
        });
    }

    odswiezPozycje() {
        if (document.documentElement.offsetHeight - window.innerHeight < this.state.scrollPositionY + 120) {
            if (JSON.parse(sessionStorage.getItem('koszyk')).length > 1) {
                this.setState({scrollPositionY: this.state.scrollPositionY - 188})
            } else {
                this.setState({scrollPositionY: this.state.scrollPositionY})
            }
        } else {
            if (JSON.parse(sessionStorage.getItem('koszyk')).length > 2) {
                this.setState({scrollPositionY: this.state.scrollPositionY - 188})
            } else {
                this.setState({scrollPositionY: this.state.scrollPositionY})
            }
        }
    }

    wyswietlNotyfikacje(typ) {
        if (typ === 'zakup') {
            NotificationManager.success("", "Dodano bilet do koszyka ", 5000);
        }
        if (typ === 'wystapilBlad') {
            NotificationManager.error("", "Wystąpił błąd ", 5000);
        }
        if (typ === 'rezerwacja') {
            NotificationManager.success("", "Dodano rezerwację do koszyka ", 5000);
        }
        if (typ === 'tylkoRezerwacja') {
            NotificationManager.error("", "Nie można łączyć w koszyku zakupów i rezerwacji. Zrealizuj koszyk. ", 5000);
        }
        if (typ === 'tylkoZakup') {
            NotificationManager.error("", "Nie można łączyć w koszyku zakupów i rezerwacji. Zrealizuj koszyk. ", 5000);
        }
        if (typ === 'brakBiletow') {
            NotificationManager.error("", "Brak możliwości zakupu biletów na danej trasie ", 5000);
        }
        if (typ === 'promocyjny') {
            NotificationManager.error("", "Możesz dodać tylko jeden bilet promocyjny na dany kurs ", 5000);

        }
    }

    wyswietlUwage(uwaga) {
        NotificationManager.error("", uwaga, 10000);
    }

    getStanKoszyka() {
        return JSON.parse(sessionStorage.getItem('koszyk')) !== null && JSON.parse(sessionStorage.getItem('koszyk')) !== undefined ? JSON.parse(sessionStorage.getItem('koszyk')).length : '0'
    }

    renderujSzczegoly(item, powrotny) {
        return <PokazSzczegoly item={item} pokazSzczegoly={(id) => this.pokazSzczegoly(id)}
                               getKoszyk={() => this.odswiezHeader()}
                               wyswietlNotyfikacje={(typ) => this.wyswietlNotyfikacje(typ)}
                               wyswietlUwage={(uwaga) => this.wyswietlUwage(uwaga)}
                               powrotny={powrotny}
                               params={this.props.match.params}
                               odswiezPozycje={() => this.odswiezPozycje()}
                               koszyk={() => this.props.koszyk()}
                               mW={this.state.miejscowoscOne} mD={this.state.miejscowoscTwo}/>
    }

    renderujCennik(item, powrotny) {
        return <ShowCennik mW={this.state.miejscowoscOne} mD={this.state.miejscowoscTwo} powrotny={powrotny}
                           item={item}/>
    }

    render() {
        return <div>

            {this.state.bledneDane ? null : <div className="wyszukiwarka2">
                <Wyszukiwarka params={this.props.match.params}
                              miejscowoscOne={(mOne) => this.setState({miejscowoscOne: mOne})}
                              miejscowoscTwo={(mTwo) => this.setState({miejscowoscTwo: mTwo})}
                              buttonLoader={this.state.buttonLoader}
                              setButtonLoader={()=>this.setState({buttonLoader: false})}
                              onButtonClick={() => {
                                  this.setState({data: [], dataPowrot: [], loading: true, wyswietlSzczegoly: {}, buttonLoader: true});
                                  this.componentWillMount()
                              }}/>
            </div>}
            <div className="wyniki">

                <div className={'stickyKoszyk'}>
                    {this.state.odliczanie ? <Link to='/koszyk'><Button
                        style={{marginTop: 6, backgroundColor: '#eeb207', color: 'white'}}>
                        <div><i className={'fa fa-shopping-cart'}/>
                            &nbsp;({this.getStanKoszyka()})
                        </div>
                        <div style={{fontSize: '0.75rem'}}>{this.state.odliczanie}</div>
                    </Button>
                    </Link> : <Link to='/koszyk'><Button
                        style={{marginTop: 16, backgroundColor: '#eeb207', color: 'white'}}>
                        <div><i className={'fa fa-shopping-cart'}/>
                            &nbsp;({this.getStanKoszyka()})
                        </div>
                    </Button>
                    </Link>}
                </div>



                {this.state.bledneDane ?
                    <div style={{paddingTop: 100, textAlign: 'center', color: '#696969'}}><h4>Podano niepoprawne
                        dane.</h4>
                        <p>Przejdź do <Link to={'/'}>wyszukiwarki</Link> i spróbuj ponownie.</p></div> :
                    <div className="pokazWyniki container" id="container">
                        {!this.state.loading ?
                            <div>
                                <div className="row koszykMobilka displayNoneMobilka">
                                    <div className="col-sm-10">
                                        <h5>{strings.wynikiWyszukiwaniaPolaczen}:</h5>
                                    </div>
                                    <div className="col-sm-2">
                                        <h5>{strings.koszyk}:</h5>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <h3 className="text-center">{strings.wyjazd}</h3>
                                        <WynikiComponent data={this.state.data}
                                                         wyswietlSzczegoly={this.state.wyswietlSzczegoly}
                                                         wyswietlCennik={this.state.wyswietlCennik}
                                                         pokazSzczegoly={(item) => this.pokazSzczegoly(item)}
                                                         pokazCennik={(item) => this.pokazCennik(item)}
                                                         renderujSzczegoly={(item, powrotny) => this.renderujSzczegoly(item, powrotny)}
                                                         renderujCennik={(item, powrotny) => this.renderujCennik(item, powrotny)}
                                                         wyswietlNotyfikacje={(item) => this.wyswietlNotyfikacje(item)}
                                                         params={this.props.match.params}/>
                                        <TopIf isTrue={this.state.powrotny}>
                                            <hr style={{marginTop: 25, marginBottom: 25}}/>
                                            <h3 className="text-center">{strings.powrot}</h3>
                                            <WynikiComponent data={this.state.dataPowrot}
                                                             powrotny={true}
                                                             wyswietlSzczegoly={this.state.wyswietlSzczegoly}
                                                             wyswietlCennik={this.state.wyswietlCennik}
                                                             pokazSzczegoly={(item) => this.pokazSzczegoly(item)}
                                                             pokazCennik={(item) => this.pokazCennik(item)}
                                                             renderujSzczegoly={(item, powrotny) => this.renderujSzczegoly(item, powrotny)}
                                                             renderujCennik={(item, powrotny) => this.renderujCennik(item, powrotny)}
                                                             wyswietlNotyfikacje={(item) => this.wyswietlNotyfikacje(item)}
                                                             params={this.props.match.params}/>

                                        </TopIf>
                                    </div>

                                    <Koszyk odswiezPozycje={() => this.odswiezPozycje()} style={{position: 'relative'}}
                                            position={this.state.scrollPositionY}
                                            containerHeight={this.state.containerHeight} koszyk={() => {
                                        this.props.koszyk()
                                    }}/>

                                </div>
                            </div>

                            :
                            <div style={{paddingTop: 100, textAlign: 'center', color: '#58b13d'}}>
                                <div className="loaderDim"><i className="fa fa-spinner fa-pulse fa-2x fa-fw"> </i></div>
                                <div style={{
                                    fontWeight: 'bold', paddingTop: 10
                                }}>{strings.trwaWyszukiwaniePolaczen}</div>
                            </div>}


                    </div>}
            </div>
            <Footer/>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/wyszukiwarka/Wyniki.js